import { Box, Typography } from "@mui/material";
import coverImage from "../../../../media/images/headCover.svg";
import BigCar from "../../../../media/images/icons/bigCar";
import BoxIcon from "../../../../media/images/icons/box";
import LinkCard from "./LinkCard";

export default function SignupGuide() {
  const links = [
    {
      title: "راهنما ثبت‌نام رانندگان",
      icon: <BigCar />,
      path: "#",
    },
    {
      title: "راهنما ثبت‌نام صاحبان کالا",
      icon: <BoxIcon />,
      path: "#",
    },
  ];

  return (
    <Box
      sx={{
        flex: "1",
      }}
    >
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          borderRadius: "20px",
          alignItems: "center",
          justifyContent: "center",
          paddingX: "16px",
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
          marginBottom: "20px",
        }}
      >
        <Typography
          sx={{
            marginTop: "32px",
            fontSize: "22px",
            fontWeight: "900",
            color: "background.default",
          }}
        >
          راهنمای بازارگاه{" "}
        </Typography>
        <Typography
          sx={{
            marginBottom: "32px",
            color: "background.default",
          }}
        >
          راهنمای ثبت نام{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          px: 3,
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
          }}
        >
          شما می‌توانید به‌عنوان راننده یا صاحب کالا در بازارگاه بار
          کارن‌ترابر نت ثبت‌نام کنید.
        </Typography>
        <Typography
          sx={{
            maxWidth: "70%",
            margin: "auto",
            textAlign: "center",
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          برای مشاهده راهنمای ثبت‌نام هرکدام، کافی‌است بر روی آن ضربه بزنید:
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginTop: "8px",
        }}
      >
        {links.map((item, index) => (
          <LinkCard {...item} index={index} />
        ))}
      </Box>
    </Box>
  );
}
